import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { StackScreenProps } from "@react-navigation/stack";
import { SleepActivityProvider } from "./SleepActivityContext";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";
import { SleepScreen } from "./screens/SleepScreen";
import { ActivityScreen } from "./screens/ActivityScreen";
import { SleepActivityCompleteScreen } from "./screens/SleepActivityCompleteScreen";

export type SleepActivityStackParamList = {
  SleepIntro: undefined;
  ActivityIntro: undefined;
  SleepActivityComplete: undefined;
};

export type SleepActivityStackScreenProps<
  T extends keyof SleepActivityStackParamList,
> = StackScreenProps<SleepActivityStackParamList, T>;

const Stack = createNativeStackNavigator<SleepActivityStackParamList>();

export function SleepActivityNavigator() {
  return (
    <SleepActivityProvider>
      <MedicalHistoryQuestionProvider
        section="sleep-activity"
        sectionLabelKey="med_history.review.section_title.sleep-activity"
        helpTextKey="med_history.question_screen.flow_help.sleep-activity"
      >
        <Stack.Navigator
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "transparent" },
          }}
        >
          <Stack.Screen name="SleepIntro" component={SleepScreen} />
          <Stack.Screen name="ActivityIntro" component={ActivityScreen} />
          <Stack.Screen
            name="SleepActivityComplete"
            component={SleepActivityCompleteScreen}
          />
        </Stack.Navigator>
      </MedicalHistoryQuestionProvider>
    </SleepActivityProvider>
  );
}
